import { BarChart } from '@mui/icons-material';
import { AuthLayout } from '../components/AuthLayout/AuthLayout';
import { AuthPromoPanel } from '../components/AuthPromoPanel/AuthPromoPanel';
import { ResetPasswordForm } from '../components/ResetPasswordForm/ResetPasswordForm';
import styles from './ForgotPasswordPage.module.css';

interface ResetPasswordPageProps {
	token: string | null;
	onSuccess?: () => void;
	onRequestNewLink?: () => void;
}

export const ResetPasswordPage = ({ token, onSuccess, onRequestNewLink }: ResetPasswordPageProps) => {
	return (
		<AuthLayout
			title="Redefinir Senha"
			subtitle="Escolha uma nova senha para acessar sua conta"
			logoClassName={styles.logo}
			headerClassName={styles.header}
			promoPanel={
				<AuthPromoPanel
					promoImageSrc="/images/login-promo-image.jpg"
					promoTitle="Alcance metas rápido"
					promoDescription="Utilize o Practium para fazer todo o controle fino da sua operação, atingindo suas metas para 2026"
					statsCard={{
						icon: <BarChart />,
						label: 'Faturamento',
						value: 'R$75 040',
					}}
					sectionHeading="Controle total da operação"
					sectionText="Tenha o controle total da sua operação na palma de suas mãos, acompanhando produção, custos, equipes e resultados em tempo real, tudo no Practium"
				/>
			}
		>
			<ResetPasswordForm token={token ?? ''} onSuccess={onSuccess} onRequestNewLink={onRequestNewLink} />
		</AuthLayout>
	);
};
